module.exports = __webpack_public_path__ + "media/images/pekarska_final-3a0131b0.mp4";